import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { rootSaga } from "../sagas";
import { rootReducer } from "../reducers";
import { chfarMiddleWare } from "../features/change-for-any-reason/reducers";

// REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(sagaMiddleware)
      .concat(chfarMiddleWare),
});

sagaMiddleware.run(rootSaga);

export type TripsState = ReturnType<typeof store.getState>;

export const useAppSelector: TypedUseSelectorHook<TripsState> = useSelector;
